<twaice-fe-svg-icon [name]="icon" [size]="size" [source]="iconSource" />

<ng-container *ngIf="expanded">
  <div class="side-nav-item__title">{{ title }}</div>
</ng-container>

<ng-container *ngIf="!expanded">
  <div class="side-nav-item__tooltip">{{ title }}</div>
</ng-container>
